function Column({ children, className = "", ...props }) {
	return (
		<th {...props} className={`main_head_item ${className}`}>
			{children}
		</th>
	);
}

export default Column;
